module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"event":{"button":"Discover all events","description":"Participate in exciting events and expand your network","title":"Next event"}}}}}}')
  delete Component.options._Ctor
}
